<template>
  <div class="switcher">
    <div class="item" :class="{ active: i === current }" v-for="i in quantity" :key="i" @click="change(i)"></div>
  </div>
</template>

<script>
export default {
  props: {
    quantity: Number,
    group: Number
  },
  data () {
    return {
      current: this.group
    }
  },
  methods: {
    change (i) {
      if (i === this.current) return
      this.current = i
      this.$emit('change', i)
    }
  }
}
</script>

<style scoped>
.switcher { align-items: center; display: flex; }
.item { background: #2c3e50; border-radius: 2px; cursor: pointer; height: 10px; position: relative; width: 20px; }
.item:not(:first-child) { margin-left: 2px; }
.item.active { background: #8c9eff; cursor: default; }
.item:not(.active):before { background: rgba(255, 255, 255, 0); border-radius: 2px; bottom: 0; content: ''; left: 0; position: absolute; right: 0; top: 0; -webkit-transition: background-color .3s; -moz-transition: background-color .3s; -o-transition: background-color .3s; transition: background-color .3s; }
.item:not(.active):hover:before { background: rgba(255, 255, 255, .05); }
</style>



// WEBPACK FOOTER //
// src/components/SportGroupSwitcher.vue